module.exports = __webpack_public_path__ + "static/media/award.0ce242d2.png";